import { render } from "./policycollectlist.vue?vue&type=template&id=68d380f7&scoped=true"
import script from "./policycollectlist.vue?vue&type=script&lang=js"
export * from "./policycollectlist.vue?vue&type=script&lang=js"

import "./policycollectlist.vue?vue&type=style&index=0&id=68d380f7&scoped=true&lang=css"

import exportComponent from "/apps/srv/jenkins/workspace/feihua_fe_mqimengweb_online/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68d380f7"]])

export default __exports__